(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bd-catalog-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-bd-catalog-home]');
    roots.forEach((root) => {
      if (root.dataset.catalogReady === 'true') return;
      root.dataset.catalogReady = 'true';
      const select = root.querySelector('[data-bd-catalog-sort]');
      const grid = root.querySelector('[data-bd-catalog-grid]');
      if (!select || !grid) return;
      const count = root.querySelector('[data-bd-product-count]');
      const available = root.querySelector('[data-bd-available]');
      select.addEventListener('change', () => {
        const cards = Array.from(grid.querySelectorAll('.bd-home-card'));
        const sorters = {
          featured: (a, b) => Number(a.dataset.position) - Number(b.dataset.position),
          newest: (a, b) => Number(b.dataset.published) - Number(a.dataset.published),
          'price-ascending': (a, b) => Number(a.dataset.price) - Number(b.dataset.price),
          'price-descending': (a, b) => Number(b.dataset.price) - Number(a.dataset.price),
          'title-ascending': (a, b) => a.dataset.title.localeCompare(b.dataset.title)
        };
        cards.sort(sorters[select.value] || sorters.featured).forEach((card) => grid.appendChild(card));
      });
      available?.addEventListener('change', () => {
        const cards = Array.from(grid.querySelectorAll('.bd-home-card'));
        cards.forEach((card) => { card.hidden = available.checked && card.dataset.available !== 'true'; });
        if (count) count.textContent = String(cards.filter((card) => !card.hidden).length);
      });
      root.querySelectorAll('[data-card-save]').forEach((button) => {
        button.addEventListener('click', () => {
          const product = button.querySelector('[data-card-product]');
          const card = button.closest('.bd-home-card');
          const sizes = Array.from(card?.querySelectorAll('[data-card-size]') || []).map((size) => ({
            label: size.dataset.sizeLabel,
            variantId: size.dataset.variantId,
            available: size.dataset.sizeAvailable === 'true'
          }));
          document.dispatchEvent(new CustomEvent('bodega:open-save', {
            detail: {
              id: product?.dataset.productId,
              title: product?.dataset.productTitle,
              url: product?.dataset.productUrl,
              image: product?.dataset.productImage,
              price: product?.dataset.productPrice,
              sizes
            }
          }));
        });
      });
      const updateSavedButtons = (savedProductIds) => {
        root.querySelectorAll('[data-card-save]').forEach((button) => {
          const id = button.querySelector('[data-card-product]')?.dataset.productId;
          button.setAttribute('aria-pressed', String(savedProductIds.includes(id)));
        });
      };
      document.addEventListener('bodega:saved-updated', (event) => {
        updateSavedButtons(event.detail?.productIds || []);
      });
      try {
        const saved = JSON.parse(localStorage.getItem('bodegaSavedItemsV1') || '[]');
        updateSavedButtons([...new Set(saved.map((item) => String(item.id)))]);
      } catch (error) {
        updateSavedButtons([]);
      }
      root.querySelectorAll('.bd-home-card').forEach((card) => {
        const slides = Array.from(card.querySelectorAll('[data-card-slide]'));
        const dots = Array.from(card.querySelectorAll('.bd-home-card__dots span'));
        if (!slides.length) return;
        let imageIndex = 0;
        const showImage = (nextIndex) => {
          imageIndex = (nextIndex + slides.length) % slides.length;
          slides.forEach((slide, index) => slide.classList.toggle('is-active', index === imageIndex));
          dots.forEach((dot, index) => dot.classList.toggle('is-active', index === imageIndex));
        };
        card.querySelector('[data-card-previous]')?.addEventListener('click', (event) => {
          event.preventDefault();
          showImage(imageIndex - 1);
        });
        card.querySelector('[data-card-next]')?.addEventListener('click', (event) => {
          event.preventDefault();
          showImage(imageIndex + 1);
        });
        const visual = card.querySelector('.bd-home-card__visual');
        let pointerStart = null;
        let swiped = false;
        visual?.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse') return;
          pointerStart = { x: event.clientX, y: event.clientY };
          swiped = false;
        });
        visual?.addEventListener('pointerup', (event) => {
          if (!pointerStart || event.pointerType === 'mouse') return;
          const deltaX = event.clientX - pointerStart.x;
          const deltaY = event.clientY - pointerStart.y;
          pointerStart = null;
          if (Math.abs(deltaX) < 36 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
          swiped = true;
          showImage(imageIndex + (deltaX < 0 ? 1 : -1));
        });
        visual?.addEventListener('pointercancel', () => { pointerStart = null; });
        visual?.addEventListener('click', (event) => {
          if (!swiped) return;
          event.preventDefault();
          swiped = false;
        });
        visual?.addEventListener('dragstart', (event) => event.preventDefault());
        showImage(0);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bd-collection"]) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-bd-collection]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      root.querySelectorAll('[data-card-save]').forEach((button) => {
        button.addEventListener('click', () => {
          const product = button.querySelector('[data-card-product]');
          const card = button.closest('.bd-collection-card');
          const sizes = Array.from(card?.querySelectorAll('[data-card-size]') || []).map((size) => ({
            label: size.dataset.sizeLabel,
            variantId: size.dataset.variantId,
            available: size.dataset.sizeAvailable === 'true'
          }));
          document.dispatchEvent(new CustomEvent('bodega:open-save', { detail: {
            id: product?.dataset.productId,
            title: product?.dataset.productTitle,
            url: product?.dataset.productUrl,
            image: product?.dataset.productImage,
            price: product?.dataset.productPrice,
            sizes
          }}));
        });
      });
      const updateSaved = (ids) => root.querySelectorAll('[data-card-save]').forEach((button) => {
        const id = button.querySelector('[data-card-product]')?.dataset.productId;
        button.setAttribute('aria-pressed', String(ids.includes(id)));
      });
      document.addEventListener('bodega:saved-updated', (event) => updateSaved(event.detail?.productIds || []));
      try {
        const saved = JSON.parse(localStorage.getItem('bodegaSavedItemsV1') || '[]');
        updateSaved([...new Set(saved.map((item) => String(item.id)))]);
      } catch (error) {
        updateSaved([]);
      }
      root.querySelectorAll('.bd-collection-card').forEach((card) => {
        const slides = Array.from(card.querySelectorAll('[data-card-slide]'));
        const dots = Array.from(card.querySelectorAll('.bd-collection-card__dots span'));
        if (!slides.length) return;
        let imageIndex = 0;
        const showImage = (nextIndex) => {
          imageIndex = (nextIndex + slides.length) % slides.length;
          slides.forEach((slide, index) => slide.classList.toggle('is-active', index === imageIndex));
          dots.forEach((dot, index) => dot.classList.toggle('is-active', index === imageIndex));
        };
        card.querySelector('[data-card-previous]')?.addEventListener('click', (event) => {
          event.preventDefault();
          showImage(imageIndex - 1);
        });
        card.querySelector('[data-card-next]')?.addEventListener('click', (event) => {
          event.preventDefault();
          showImage(imageIndex + 1);
        });
        const visual = card.querySelector('.bd-collection-card__visual');
        let pointerStart = null;
        let swiped = false;
        visual?.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse') return;
          pointerStart = { x: event.clientX, y: event.clientY };
          swiped = false;
        });
        visual?.addEventListener('pointerup', (event) => {
          if (!pointerStart || event.pointerType === 'mouse') return;
          const deltaX = event.clientX - pointerStart.x;
          const deltaY = event.clientY - pointerStart.y;
          pointerStart = null;
          if (Math.abs(deltaX) < 36 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
          swiped = true;
          showImage(imageIndex + (deltaX < 0 ? 1 : -1));
        });
        visual?.addEventListener('pointercancel', () => { pointerStart = null; });
        visual?.addEventListener('click', (event) => {
          if (!swiped) return;
          event.preventDefault();
          swiped = false;
        });
        visual?.addEventListener('dragstart', (event) => event.preventDefault());
        showImage(0);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bd-header"]) return;
  try {
    
  (() => { const header=document.querySelector('[data-bd-header]'); const drawer=document.querySelector('[data-menu-drawer]'); const backdrop=document.querySelector('[data-menu-backdrop]'); const openButton=header?.querySelector('[data-menu-open]'); if(!header||!drawer||!backdrop||!openButton||header.dataset.menuReady==='true')return; header.dataset.menuReady='true'; const openMenu=()=>{drawer.classList.add('is-open');drawer.setAttribute('aria-hidden','false');openButton.setAttribute('aria-expanded','true');backdrop.hidden=false;document.documentElement.classList.add('bd-menu-open');drawer.querySelector('[data-menu-close]')?.focus()}; const closeMenu=()=>{drawer.classList.remove('is-open');drawer.setAttribute('aria-hidden','true');openButton.setAttribute('aria-expanded','false');backdrop.hidden=true;document.documentElement.classList.remove('bd-menu-open')}; openButton.addEventListener('click',openMenu);drawer.querySelector('[data-menu-close]')?.addEventListener('click',closeMenu);backdrop.addEventListener('click',closeMenu);drawer.querySelectorAll('a').forEach(link=>link.addEventListener('click',closeMenu));drawer.querySelector('[data-saved-open]')?.addEventListener('click',closeMenu);document.addEventListener('keydown',event=>{if(event.key==='Escape'&&drawer.classList.contains('is-open'))closeMenu()})})();

  (() => {
    const storageKey = 'bodegaSavedItemsV1';
    const drawer = document.querySelector('[data-saved-drawer]');
    const backdrop = document.querySelector('[data-saved-backdrop]');
    if (!drawer || drawer.dataset.ready === 'true') return;
    drawer.dataset.ready = 'true';
    document.body.append(backdrop, drawer);
    const prompt = drawer.querySelector('[data-saved-prompt]');
    const list = drawer.querySelector('[data-saved-list]');
    const countNodes = document.querySelectorAll('[data-saved-count]');
    const itemsNode = drawer.querySelector('[data-saved-items]');
    const emptyNode = drawer.querySelector('[data-saved-empty]');
    const confirmButton = drawer.querySelector('[data-saved-confirm]');
    const sizeFieldset = drawer.querySelector('[data-saved-size-fieldset]');
    const sizeOptions = drawer.querySelector('[data-saved-size-options]');
    const errorNode = drawer.querySelector('[data-saved-error]');
    let pendingProduct = null;
    let selectedSize = null;

    const getSaved = () => {
      try {
        const saved = JSON.parse(localStorage.getItem(storageKey) || '[]');
        return Array.isArray(saved) ? saved : [];
      } catch (error) {
        return [];
      }
    };
    const setSaved = (saved) => {
      localStorage.setItem(storageKey, JSON.stringify(saved));
      updateSavedState(saved);
    };
    const updateSavedState = (saved = getSaved()) => {
      countNodes.forEach((node) => { node.textContent = String(saved.length); });
      document.dispatchEvent(new CustomEvent('bodega:saved-updated', {
        detail: { productIds: [...new Set(saved.map((item) => String(item.id)))] }
      }));
    };
    const openDrawer = (mode = 'list') => {
      prompt.hidden = mode !== 'prompt';
      list.hidden = mode !== 'list';
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      backdrop.hidden = false;
      document.documentElement.classList.add('bd-saved-open');
      drawer.querySelector('[data-saved-close]')?.focus();
    };
    const closeDrawer = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      backdrop.hidden = true;
      document.documentElement.classList.remove('bd-saved-open');
    };
    const renderSaved = () => {
      const saved = getSaved();
      itemsNode.innerHTML = '';
      emptyNode.hidden = saved.length > 0;
      saved.forEach((item) => {
        const article = document.createElement('article');
        article.className = 'bd-saved-item';
        const image = document.createElement('img');
        image.src = item.image || '';
        image.alt = item.title || '';
        image.width = 96;
        image.height = 120;
        const details = document.createElement('div');
        const title = document.createElement('h3');
        title.textContent = item.title || '';
        const price = document.createElement('p');
        price.textContent = item.price || '';
        const size = document.createElement('p');
        size.textContent = item.size ? `${drawer.dataset.sizeText || 'Size'}: ${item.size}` : '';
        const actions = document.createElement('div');
        actions.className = 'bd-saved-item__actions';
        const view = document.createElement('a');
        view.href = item.variantId ? `${item.url}?variant=${item.variantId}` : item.url;
        view.textContent = drawer.dataset.viewText || 'View product';
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.textContent = drawer.dataset.removeText || 'Remove';
        remove.addEventListener('click', () => {
          setSaved(getSaved().filter((savedItem) => savedItem.key !== item.key));
          renderSaved();
        });
        actions.append(view, remove);
        details.append(title, price, size, actions);
        article.append(image, details);
        itemsNode.append(article);
      });
      updateSavedState(saved);
    };

    document.querySelectorAll('[data-saved-open]').forEach((button) => {
      button.addEventListener('click', () => {
        renderSaved();
        openDrawer('list');
      });
    });
    drawer.querySelector('[data-saved-close]')?.addEventListener('click', closeDrawer);
    backdrop.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
    document.addEventListener('bodega:open-save', (event) => {
      pendingProduct = event.detail;
      selectedSize = null;
      drawer.querySelector('[data-saved-prompt-image]').src = pendingProduct.image || '';
      drawer.querySelector('[data-saved-prompt-image]').alt = pendingProduct.title || '';
      drawer.querySelector('[data-saved-prompt-title]').textContent = pendingProduct.title || '';
      drawer.querySelector('[data-saved-prompt-price]').textContent = pendingProduct.price || '';
      sizeOptions.innerHTML = '';
      const availableSizes = (pendingProduct.sizes || []).filter((size) => size.available);
      sizeFieldset.hidden = pendingProduct.sizes.length === 0;
      pendingProduct.sizes.forEach((size) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = size.label;
        button.disabled = !size.available;
        button.addEventListener('click', () => {
          selectedSize = size;
          sizeOptions.querySelectorAll('button').forEach((option) => option.classList.toggle('is-selected', option === button));
          confirmButton.disabled = false;
          errorNode.hidden = true;
        });
        sizeOptions.append(button);
      });
      confirmButton.disabled = pendingProduct.sizes.length > 0;
      if (pendingProduct.sizes.length === 1 && availableSizes.length === 1) {
        sizeOptions.querySelector('button')?.click();
      }
      errorNode.hidden = true;
      openDrawer('prompt');
    });
    confirmButton.addEventListener('click', () => {
      if (!pendingProduct) return;
      if (pendingProduct.sizes.length > 0 && !selectedSize) {
        errorNode.hidden = false;
        return;
      }
      const saved = getSaved();
      const variantId = selectedSize?.variantId || '';
      const key = `${pendingProduct.id}:${variantId || 'default'}`;
      const nextSaved = saved.filter((item) => item.key !== key);
      nextSaved.push({
        key,
        id: String(pendingProduct.id),
        title: pendingProduct.title,
        url: pendingProduct.url,
        image: pendingProduct.image,
        price: pendingProduct.price,
        size: selectedSize?.label || '',
        variantId
      });
      setSaved(nextSaved);
      renderSaved();
      openDrawer('list');
    });
    renderSaved();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bd-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-variant-picker]').forEach((picker) => {
      if (picker.dataset.ready === 'true') return;
      picker.dataset.ready = 'true';
      const trigger = picker.querySelector('[data-variant-trigger]');
      const label = picker.querySelector('[data-variant-label]');
      const menu = picker.querySelector('[data-variant-menu]');
      const nativeSelect = picker.querySelector('[data-variant]');
      const options = Array.from(picker.querySelectorAll('[data-variant-option]'));
      if (!trigger || !label || !menu || !nativeSelect) return;
      const close = (restoreFocus = false) => {
        menu.hidden = true;
        picker.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        if (restoreFocus) trigger.focus();
      };
      const open = () => {
        menu.hidden = false;
        picker.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      };
      trigger.addEventListener('click', () => {
        if (menu.hidden) open();
        else close();
      });
      options.forEach((option) => {
        option.addEventListener('click', () => {
          if (option.disabled) return;
          nativeSelect.value = option.dataset.value;
          label.textContent = option.dataset.label;
          options.forEach((item) => item.setAttribute('aria-selected', String(item === option)));
          nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
          close(true);
        });
      });
      menu.addEventListener('keydown', (event) => {
        const enabled = options.filter((option) => !option.disabled);
        const current = enabled.indexOf(document.activeElement);
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          const direction = event.key === 'ArrowDown' ? 1 : -1;
          enabled[(current + direction + enabled.length) % enabled.length]?.focus();
        }
        if (event.key === 'Escape') close(true);
      });
      document.addEventListener('click', (event) => {
        if (!picker.contains(event.target)) close();
      });
    });
    document.querySelectorAll('[data-bd-lifestyle]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const track = root.querySelector('[data-lifestyle-track]');
      const slides = Array.from(root.querySelectorAll('[data-lifestyle-slide]'));
      const dots = Array.from(root.querySelectorAll('[data-lifestyle-dot]'));
      const previous = root.querySelector('[data-lifestyle-previous]');
      const next = root.querySelector('[data-lifestyle-next]');
      if (!track || slides.length < 2) return;
      const setCurrent = (index) => {
        dots.forEach((dot, dotIndex) => {
          if (dotIndex === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };
      const updateArrows = () => {
        if (!previous || !next) return;
        const maximum = Math.max(track.scrollWidth - track.clientWidth, 0);
        previous.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= maximum - 1;
      };
      const scrollOne = (direction) => {
        const step = slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : slides[0].getBoundingClientRect().width;
        track.scrollBy({ left: direction * step, behavior: 'smooth' });
      };
      let frame;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
          setCurrent(Math.min(Math.max(index, 0), slides.length - 1));
          updateArrows();
        });
      }, { passive: true });
      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => slides[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' }));
      });
      if (previous && next) {
        previous.addEventListener('click', () => scrollOne(-1));
        next.addEventListener('click', () => scrollOne(1));
        window.addEventListener('resize', updateArrows, { passive: true });
        updateArrows();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
